import { render, staticRenderFns } from "./ContentOutput.vue?vue&type=template&id=2ba9e9b9"
import script from "./ContentOutput.vue?vue&type=script&lang=js"
export * from "./ContentOutput.vue?vue&type=script&lang=js"
import style0 from "./ContentOutput.vue?vue&type=style&index=0&id=2ba9e9b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports